/**
 *
 * @license
 * Copyright 2017 SAP Ariba
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CardComponent, CardZoneBottomComponent, CardZoneTopComponent} from './card.component';
import {CardZoneTitleComponent} from './card-title/card-title.component';


@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        CardComponent,
        CardZoneTitleComponent,
        CardZoneTopComponent,
        CardZoneBottomComponent
    ],
    entryComponents: [
        CardComponent
    ],
    exports: [
        CardComponent,
        CardZoneTitleComponent,
        CardZoneTopComponent,
        CardZoneBottomComponent
    ],
    providers: []
})
export class AWCardModule
{
}
